import { DiscountCodeApi } from 'common/types';
import { TFunction } from 'react-i18next';

export interface DiscountCodesTableRow {
	id: string;
	code: string;
	discountPercentage: number | null;
	discountAmount: number | null;
	validFor: string;
	usageCount: number;
}

export const discountCodeToDiscountCodesTableRow = (deps: { t: TFunction }) => (
	discountCode: DiscountCodeApi,
): DiscountCodesTableRow => {
	const { t } = deps;
	return {
		id: discountCode.id,
		code: discountCode.code,
		discountPercentage:
			discountCode.priceRule.valueType === 'percentage' ? discountCode.priceRule.value : 0,
		discountAmount:
			discountCode.priceRule.valueType === 'fixed_amount' ? discountCode.priceRule.value : 0,
		validFor: getValidForString(discountCode, t),
		usageCount: discountCode.usageCount,
	};
};

const getValidForString = (discountCode: DiscountCodeApi, t: TFunction) => {
	const productLimitCount = discountCode.entitledProductIds?.length;
	const categoryLimitCount = discountCode.entitledCategoryIds?.length;
	if (productLimitCount != null) {
		return productLimitCount === 1
			? t('discount.validForProducts_singular', {
					amount: productLimitCount,
					defaultValue: 'Valid for {{amount}} product',
			  })
			: t('discount.validForProducts', {
					amount: productLimitCount,
					defaultValue: 'Valid for {{amount}} products',
			  });
	}
	if (categoryLimitCount != null) {
		return categoryLimitCount === 1
			? t('discount.validForCategories_singular', {
					amount: categoryLimitCount,
					defaultValue: 'Valid for {{amount}} category',
			  })
			: t('discount.validForCategories', {
					amount: categoryLimitCount,
					defaultValue: 'Valid for {{amount}} categories',
			  });
	}
	return t('discount.validForEntireOrder', 'Valid for entire order');
};
